import { Component, Input, OnInit, Output, EventEmitter, OnChanges } from '@angular/core';
import { Data2Service } from '../../common/data2.service';
import { DateService } from '../../common/date.service';
import { UuidService } from '../../common/uuid.service';

@Component({
	selector: 'app-leads-show-tasks',
	templateUrl: './leads-show-tasks.component.html',
	styleUrls: ['./leads-show-tasks.component.css'],
})
export class LeadsShowTasksComponent implements OnInit, OnChanges {
	tasksNew: Array<any>;
	tasksDone: Array<any>;
	lead = {
		content: null,
		owner: null,
		start_date: null,
		start_time: null,
		type: null,
	};
	errors = {
		content: null,
		start_date: null,
		start_time: null,
		type: null,
	};
	types = [
		{
			id: 'TASK',
			name: 'Notatka',
			color: 'purple',
		},
		{
			id: 'CALL',
			name: 'Telefon',
			color: 'green',
		},
		{
			id: 'MAIL',
			name: 'Mail',
			color: 'pink',
		},
		{
			id: 'MEETING',
			name: 'Spotkanie',
			color: 'orange',
		},
	];
	@Input() leadId: number;
	@Input() tasks: Array<any>;
	@Input() users: Array<any>;
	@Output() changed = new EventEmitter();
	finishId: number = null;
	revertId: number = null;

	constructor(
		private readonly api: Data2Service,
		private readonly date: DateService,
		private readonly uuid: UuidService,
	) {}

	ngOnInit(): void {
		const date = this.date.now();
		this.lead.start_date = date.date;
		this.lead.start_time = date.time;
	}

	ngOnChanges() {
		if (this.tasks == undefined) {
			return;
		}
		this.tasks.forEach((obj) => {
			obj.author = this.find(obj.author);
			obj.owner = this.find(obj.owner);
		});
		this.tasksNew = this.tasks.filter((obj) => obj.status == 1);
		this.tasksDone = this.tasks.filter((obj) => obj.status == 2);
	}

	private find(obj) {
		const find = this.users.find((objFind) => objFind.id == obj);
		return find ? find.name : '?';
	}

	submit(): void {
		let hasErrors = false;
		for (const key in this.errors) {
			if (!this.lead[key]) {
				this.errors[key] = true;
				hasErrors = true;
				continue;
			}
			this.errors[key] = false;
		}
		if (hasErrors) {
			return;
		}
		const data = {
			id: this.uuid.generate(),
			content: this.lead.content,
			owner: this.lead.owner,
			start_date: this.date.localToUtcIso(this.lead.start_date + 'T' + this.lead.start_time),
			type: this.lead.type,
		};
		this.api.post('/leads/' + this.leadId + '/taskAdd/', data, (result, error) => {
			if (error) {
				alert('error - check console');
				return;
			}
			this.lead.content = null;
			this.lead.owner = null;
			this.lead.type = null;
			this.changed.emit();
		});
	}

	askFinish(id: number): void {
		this.finishId = id;
		const element = document.getElementById('askFinishModal');
		element.style.display = 'block';
		element.style.paddingRight = '17px';
		element.className = 'modal fade show';
	}

	askNo() {
		const element = document.getElementById('askFinishModal');
		element.style.display = 'none';
		element.className = 'modal fade';
	}

	askYes(): void {
		this.askNo();
		if (!this.finishId) {
			return;
		}
		this.api.post(
			'/leads/' + this.leadId + '/taskStatus/' + this.finishId + '/',
			{ status: 2 },
			(result, error) => {
				if (error) {
					alert('error - check console');
					return;
				}
				this.changed.emit();
			},
		);
	}

	askRevert(id: number): void {
		this.revertId = id;
		const element = document.getElementById('askRevertModal');
		element.style.display = 'block';
		element.style.paddingRight = '17px';
		element.className = 'modal fade show';
	}

	askRNo() {
		const element = document.getElementById('askRevertModal');
		element.style.display = 'none';
		element.className = 'modal fade';
	}

	askRYes(): void {
		this.askRNo();
		if (!this.revertId) {
			return;
		}
		this.api.post(
			'/leads/' + this.leadId + '/taskStatus/' + this.revertId + '/',
			{ status: 1 },
			(result, error) => {
				if (error) {
					alert('error - check console');
					return;
				}
				this.changed.emit();
			},
		);
	}
}
